import * as React from "react";
import styled, { keyframes } from "styled-components";
import { useEffect, useState } from "react";
import usePrevious from "./usePrevious";

const EmptyProgressBar = keyframes`
	0% {
    width: 100%;
    background: #80805c;
  }

  50% {
    background: orange;
  }
  
	100% {
    width: 0%;
    background: red;

  }
`;

const FadeInBackground = keyframes`
	0% {
    opacity: 0;
    transform: scaleX(0);
  }  
	50% {
    transform: scaleX(1);
  }  
	100% {
    opacity: 1;
    transform: scaleX(1);
  }
`;

const FadeInText = keyframes`
	0% {
    color: black;
  }  
	50% {
    color: white;
  }  
	100% {
    color: black;
  }
`;

const TimesUpAnimation = keyframes`
   0%  { opacity: 1; }
   3%  { opacity: 1; }
   10%  { opacity: 0.5; }
   17%  { opacity: 1; }
   25%  { opacity: 0.5; }
   33%  { opacity: 1; }
   41%  { opacity: 0.3; }
   49%  { opacity: 1; }
   56%  { opacity: 0.3; }
   63%  { opacity: 1; }
   69%  { opacity: 0.1; }
   75%  { opacity: 1; }
   80%  { opacity: 0.1; }
   84%  { opacity: 1; }
   88%  { opacity: 0; }
   92%  { opacity: 1; }
   95%  { opacity: 0; }
   98%  { opacity: 1; }
  100%  { opacity: 0; }
`;

const Progress = styled.div<{ max: number }>`
  height: 20px;
  background: #b5b58f;
  display: flex;
  width: 50%;
  position: relative;
  margin-left: 5px;
  border-radius: 10px;
  margin-top: 20px;
  overflow: hidden;
  animation: ${FadeInBackground} linear forwards 1s,
    ${TimesUpAnimation} ${({ max }) => 7}s linear infinite
      ${({ max }) => Math.abs(7 - max)}s;

  &:after {
    content: "";
    height: 20px;
    position: absolute;
    border-radius: 10px;
    animation: ${EmptyProgressBar} linear forwards ${({ max }) => max}s;
  }
`;

const StyledCountdown = styled.strong`
  margin: auto;
  z-index: 5;
  font-size: 1rem;
  color: black;
  animation: ${FadeInText} linear forwards 2s;
`;

const timeLimit = 30; // seconds
var interval: ReturnType<typeof setInterval>;

interface Props {
  cards: number[];
  handleAutomaticCardPlayed: () => void;
}

const TimeLimit = ({ handleAutomaticCardPlayed, cards }: Props) => {
  const [countDown, setCountDown] = useState(timeLimit);
  const previousCards = usePrevious(cards);
  useEffect(() => {
    if (JSON.stringify(previousCards) !== JSON.stringify(cards)) {
      if (interval) {
        clearInterval(interval);
      }
      setCountDown(timeLimit);
      interval = setInterval(
        () => setCountDown((countDown) => Math.max(0, countDown - 1)),
        1000
      );
    }
  }, [cards, previousCards]);
  useEffect(() => {
    if (countDown <= 0) {
      handleAutomaticCardPlayed();
      setCountDown(timeLimit);
    }
  }, [countDown, handleAutomaticCardPlayed]);
  return (
    <>
      <Progress max={timeLimit} key={JSON.stringify(cards)}>
        <StyledCountdown>{countDown} secs left</StyledCountdown>
      </Progress>
    </>
  );
};

export default TimeLimit;
